import styled from 'styled-components';

import { CheckoutPrice } from '@sharedComponents/Prices';
import { StyledPointerEventsWrapper } from '@styles/generalStyles';

export const StyledPrice = styled(CheckoutPrice)`
  display: inline-flex;
`;

export const StyledInfo = styled(StyledPointerEventsWrapper)`
  display: inline-block;
`;
